import type { Guide } from '../types';

/** S-20.10-09 — powód przekazania do Trade i zwrotu do FTL z listy (scenariusz e2e 12, BR-TRD-11). */
export const guide: Guide = {
  flagKey: 'tradeTransferReasons',
  title: 'Powód przekazania do Trade i zwrotu do FTL z listy',
  whatItDoes:
    'Przy przekazaniu zlecenia do Trade i przy zwrocie do FTL powód wybiera się z listy, a obok można dopisać komentarz („inny” wymaga komentarza). Powód trafia do historii zmian, na kartę zlecenia i pod stan na liście; w banku jest filtr „Powód przekazania/zwrotu”. Listy powodów to wartości robocze — administrator zmienia je na ekranie „Powody przekazania do Trade”.',
  audience: ['planista FTL', 'Trade', 'administrator'],
  presentationItems: ['S-20.10-09'],
  steps: [
    {
      route: '/trade-transfer-reasons',
      target: 'reasons-handover',
      title: 'Powody przekazania do Trade',
      description:
        'Lista powodów, z której wybiera planista przy „Zmień stan” → „Przekazane do Trade”. Administrator dodaje, zmienia i wycofuje pozycje — z powodem zmiany i historią.',
      action: 'Otwórz „Powody przekazania do Trade” w menu i popraw listę, jeśli trzeba.',
      recorder: { account: 'admin' },
    },
    {
      route: '/trade-transfer-reasons',
      target: 'reasons-return',
      title: 'Powody zwrotu do FTL',
      description:
        'Osobna lista dla zwrotu z Trade do FTL. Przy zwrocie powód z listy jest wymagany — bez niego „Zmień” jest nieaktywne.',
      action: 'Przy zwrocie zlecenia wybierz powód z listy i, jeśli trzeba, dopisz komentarz.',
      recorder: { account: 'admin' },
    },
  ],
};
